import React from 'react';
import { StringHelpers, SystemText } from 'e4shared';
import Panel from 'components/general/panel';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';

export const StaffObjectives = ({ focus, data, setShow }) => {
    if (!data || data.length === 0) return null;
    const total = data.length;
    const staffTotal = data.reduce((a, d) => (a.some(y => y === d.profile_Id) ? a : a.concat([d.profile_Id])), []).length;

    const message = SystemText(`Home/Widgets/WhatsHappening/StaffObjectives`, staffTotal);

    // const message = `You have ${staffTotal} staff ${StringHelpers.pluralise(
    //     'member',
    //     staffTotal
    // )} with objectives requiring your approval.`;

    const url = total === 1 ? `/objectives/${data[0].profile_Id}/objective/${data[0].id}` : '';

    const date = total === 1 ? data[0].scheduled : null;

    if (focus) {
        return (
            <FocusTile
                tileType="review"
                colour="yellow"
                icon="fa-users"
                message={message}
                url={url}
                setShow={setShow}
                date={date}
            />
        );
    }

    return <Panel colour="warning" icon="exclamation" message={message} url={url} setShow={setShow} />;
};

export default StaffObjectives;
